export const isWechat = function() {
    return /(MicroMessenger)/i.test(navigator.userAgent)
}

export const isIos = function(){
	return /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)
}